export const dropReportsEndpointIds = {
    GENERATE_DROP_REPORT: 'GENERATE_DROP_REPORT',
};
